import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import HeaderLogoOnly from 'components/HeaderLogoOnly'
import Footer from 'components/Footer'
import { getPrivacy } from 'apis/pages'
import { Page } from 'apis/response_types'
import ReactHtmlParser from 'react-html-parser'
import MetaTag from 'components/common/MetaTag'
import BreadCrumbs, { BreadCrumb } from 'components/common/BreadCrumbs'
import Container from 'components/common/Container'
import CompliancePages from 'components/common/CompliancePages'

export default function TermsView() {
  const [privacy, setPrivacy] = useState<Page[] | null>(null)
  const breadcrumbsList: BreadCrumb[] = [{ name: '個人情報の取り扱いについて(YOOR)' }]
  useEffect(() => {
    ;(async () => {
      const response = await getPrivacy()
      setPrivacy(response?.data?.data)
    })()
  }, [])
  return (
    <React.Fragment>
      <MetaTag
        title="個人情報の取り扱いについて(YOOR) - オンラインサロンYOOR（ユア）"
        description="オンラインサロンYOOR（ユア）の個人情報の取り扱いについて(YOOR)のご案内です。"
      />
      <HeaderLogoOnly />
      <Main>
        <Container>
          <BreadCrumbsStyled breadcrumbsList={breadcrumbsList} />
          {privacy?.map((p, i) => (
            <CompliancePages key={i} title={p.title} content={ReactHtmlParser(p?.entry || '')} />
          ))}
        </Container>
      </Main>
      <Footer />
    </React.Fragment>
  )
}

const Main = styled.main`
  position: relative;
  padding-top: 72px;
  display: flex;
  flex: 1;
  flex-direction: column;
  @media (max-width: 1280px) {
    padding-top: 61px;
  }
  @media (max-width: 480px) {
    padding-top: 47px;
  }
`

const BreadCrumbsStyled = styled(BreadCrumbs)`
  max-width: 860px;
`
